import {TextField, InputAdornment, IconButton} from "@mui/material";
import {useState} from "react";

function CommonPhoneNumberTextField({
                                        label,
                                        inputValue,
                                        onHandleChange,
                                        validator,
                                        sx = {},
                                        borderRadius = "8px",
                                        maxLength = 10,
                                        placeholder = "Type here...",
                                        disabled = false
                                    }) {
    const [error, setError] = useState(false);
    const [helpertext, setHelperText] = useState("");

    function handleChange(e) {
        const changedValue = e.target.value;
        if (/^\d*$/.test(changedValue) && changedValue.length <= maxLength) {
            onHandleChange(e);

            if (validator) {
                const {isValid, message} = validator(changedValue) || {
                    isValid: true,
                    message: "",
                };
                setError(!isValid);
                setHelperText(message);
            }
        }
    }

    return (
        <TextField
            label={label}
            placeholder={placeholder}
            value={inputValue}
            onChange={handleChange}
            type="text"
            helperText={helpertext}
            error={error}
            fullWidth
            disabled={disabled}
            margin="normal"
            sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: borderRadius,
                    "&.Mui-error": {
                        borderColor: "red",
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "red",
                        },
                    },
                },
                "& .MuiFormHelperText-root.Mui-error": {
                    color: "red",
                },
                ...sx,
            }}
        />
    );
}

function CommonEmailTextField({
                                  label,
                                  inputValue,
                                  onHandleChange,
                                  borderRadius = "8px",
                                  validator,
                                  sx = {},
                                  disabled = false,
                                  endAdornmentIcons,
                                  otherProps,
                                  placeholder = "Type here...",
                              }) {
    const [error, setError] = useState(false);
    const [helpertext, setHelperText] = useState("");

    function handleChange(e) {
        const value = e.target.value;
        onHandleChange(e);
        if (validator) {
            const {isValid, message} = validator(value) || {
                isValid: true,
                message: "",
            };
            setError(!isValid);
            setHelperText(message);
        }
    }

    return (
        <TextField
            label={label}
            placeholder={placeholder}
            value={inputValue}
            onChange={handleChange}
            type="text"
            error={error}
            helperText={helpertext}
            fullWidth
            disabled={disabled}
            margin="normal"
            sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: borderRadius,
                    "&.Mui-error": {
                        borderColor: "red",
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "red",
                        },
                    },
                },
                "& .MuiFormHelperText-root.Mui-error": {
                    color: "red",
                },
                ...sx,
            }}
            InputProps={{
                endAdornment: endAdornmentIcons ? (
                    <InputAdornment position="end">{endAdornmentIcons}</InputAdornment>
                ) : null,
                ...otherProps,
            }}
        />
    );
}


function CommonDecimalTextField({
                                    label,
                                    inputValue,
                                    onHandleChange,
                                    validator,
                                    sx = {},
                                    borderRadius = "8px",
                                    maxLength = 10,
                                    placeholder = "Type here...",
                                    disabled = false,
                                }) {
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState("");

    function handleChange(e) {
        const changedValue = e.target.value;
        if (/^\d*\.?\d*/.test(changedValue) && changedValue.length <= maxLength) {
            onHandleChange(e);

            if (validator) {
                const {isValid, message} = validator(changedValue) || {
                    isValid: true,
                    message: "",
                };
                setError(!isValid);
                setHelperText(message);
            }
        }
    }

    return (
        <TextField
            label={label}
            placeholder={placeholder}
            value={inputValue}
            onChange={handleChange}
            type="text"
            helperText={helperText}
            error={error}
            fullWidth
            disabled={disabled}
            margin="normal"
            sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: borderRadius,
                    "&.Mui-error": {
                        borderColor: "red",
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "red",
                        },
                    },
                },
                "& .MuiFormHelperText-root.Mui-error": {
                    color: "red",
                },
                ...sx,
            }}
        />
    );
}

function CommonTextField({
                             label,
                             inputValue,
                             onHandleChange,
                             borderRadius = "8px",
                             validator,
                             sx = {},
                             disabled = false,
                             endAdornmentIcons,
                             otherProps,
                             placeholder = "Type here...",
                         }) {
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState("");

    function handleChange(e) {
        const value = e.target.value;
        onHandleChange(e);
        if (validator) {
            const {isValid, message} = validator(value) || {
                isValid: true,
                message: "",
            };
            setError(!isValid);
            setHelperText(message);
        }
    }

    return (
        <TextField
            label={label}
            placeholder={placeholder}
            value={inputValue}
            onChange={handleChange}
            type="text"
            error={error}
            helperText={helperText}
            fullWidth
            disabled={disabled}
            margin="normal"
            sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: borderRadius,
                    "&.Mui-error": {
                        borderColor: "red",
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "red",
                        },
                    },
                },
                "& .MuiFormHelperText-root.Mui-error": {
                    color: "red",
                },
                ...sx,
            }}
            InputProps={{
                endAdornment: endAdornmentIcons ? (
                    <InputAdornment position="end">{endAdornmentIcons}</InputAdornment>
                ) : null,
                ...otherProps,
            }}
        />
    );
}


export {CommonPhoneNumberTextField, CommonEmailTextField, CommonDecimalTextField, CommonTextField};
